<template>
  <div>
    <div>
      <h4 class="mt-3 mb-3">Chart Data</h4>
      <vs-row vs-w="12">
        <vs-col vs-type="flex"  vs-align="center" vs-lg="2" vs-sm="4" vs-xs="12" >
        <h6 class="mt-2 mb-3" >Select Value to Show</h6>
        </vs-col>
      </vs-row>
      <vs-row class="mt-">
        <vs-col vs-lg="3" vs-xs="6"  vs-sm="6" v-for="item in this.header" :key="item.id">
          <vs-checkbox
            v-model="checkarray1"
            :vs-value="item.head"
            color="#333f50"
            style="justify-content: start; padding-bottom: 5%"
          >{{item.head}}</vs-checkbox>
        </vs-col>
      </vs-row><br>
      <vs-row vs-w="12">
  <vs-col vs-type="flex"  vs-align="center" vs-lg="2" vs-sm="4" vs-xs="12" >
    <h6 class="mt-2 mb-2" >Select Time Length</h6>
  </vs-col>
  <vs-col  vs-type="flex"  vs-align="center" vs-lg="3" vs-sm="4" vs-xs="12">
     <vs-select
         style="padding: 0px;"
          class="selectExample container-fluid mt-2 mb-2"
          v-model="timeselected">
          <vs-select-item :key="index" :value="item.value" :text="item.name" v-for="(item,index) in timelength" />
        </vs-select>
  </vs-col>
  
</vs-row>
      
      <vs-row>
        <vs-col vs-lg="3" vs-xs="6" >
         
        </vs-col>
      </vs-row>
     <br>
      <vs-row v-if="!timeselected">
        <vs-col class="mt-2" vs-lg="3" vs-xs="12">
          <p>Select Start Date</p>
          <!-- <datetime v-model="mintime" format="YYYY/MM/DD H:i:s" bootstrap-styling = "true" /> -->
          <datetime v-model="mintime" type="datetime"></datetime>
        </vs-col>
        <vs-col class="mt-2" vs-lg="3" vs-xs="12">
          <p>Select End Date</p>
          <!-- <datetime v-model="maxtime" format="YYYY/MM/DD H:i:s"/> -->
          <datetime v-model="maxtime" type="datetime"></datetime>
        </vs-col>
        <vs-col vs-lg="4" vs-xs="12" v-if="type == 'powermeter'">
          <p>Select Location</p>
          <vs-dropdown class="mr-4">
            <a class="a-icon" href.prevent>
              {{text}}
              <vs-icon class icon="expand_more"></vs-icon>
            </a>
            <vs-dropdown-menu>
              <vs-dropdown-item
                v-for="item in location"
                :key="item"
                @click="actionchange(item)"
              >{{item}}</vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </vs-col>
      </vs-row>
      <br />
      <vs-row class="mt-1 mb-2" vs-w="12">
        <vs-col class="mt-1 " vs-lg="12" vs-sm="12" vs-xs="12">
          <vs-button class="bts" color="success" @click="new_rerender()" :disabled="isshow" type="filled">Show</vs-button>
          <vs-button class="ml-2 bts" color="black" @click="close()" :disabled="!isshow" type="filled">Clear</vs-button>
        </vs-col>
      </vs-row> <br> 
      <!-- <vs-row>
        <vs-col vs-lg="1" vs-xs="2">
          <vs-button type="filled" @click="new_rerender()" color="#e74639" :disabled="isshow">Show</vs-button>
        </vs-col>
        <vs-col vs-lg="1" vs-xs="2">
          <vs-button type="filled" @click="close()" color="#333f50">Close</vs-button>
        </vs-col>
      </vs-row> --> 
<!-- <button @click="exportToPDF">Export to PDF</button> -->
     <div  ref="document">
     <div id="print" class="A4">
      <!-- <div class="pageout">
        <LineChart
            ref="print"
            v-if="this.render"
            :labels="this.labels"
            :datasets="this.datasets"
            :unit="this.unit"
        />
      </div> -->
      
      <div class="preview">
        <LineChart
         ref="print"
          v-if="this.render"
          :labels="this.labels"
          :datasets="this.datasets"
          :unit="this.unit"
        />
      </div> 
    </div>
      <br />
      <!-- <vs-button type="filled" v-if="this.render" color="#333f50" @click="savePDF()">Export</vs-button>
    -->

      <!-- <div id="print" class="A4 pageout">
        <LineChart
         ref="print"
          :labels="this.labels"
          :datasets="this.datasets"
          :unit="this.unit"
          v-if="this.render"
        />
      </div>-->
       <br>
      <vs-table v-if="this.render && this.type != 'control'" :data="MaxValue">
        <vs-th style="padding: 0px">Name value</vs-th>
        <vs-th style="padding: 0px">Min value</vs-th>
        <vs-th style="padding: 0px">Max value</vs-th>
        <vs-th style="padding: 0px">Average value</vs-th>
        <vs-tr v-for="(value,index) in MaxValue" :key="index">
          <vs-td>{{tablelabels[index]}}</vs-td>
          <vs-td>{{MinValue[index]}}</vs-td>
          <vs-td>{{MaxValue[index]}}</vs-td>
          <vs-td>{{AvgValue[index]}}</vs-td>
        </vs-tr>
      </vs-table>
  
   </div>
     </div> 
  </div>
</template>

<script>
import VueHtml2pdf from 'vue-html2pdf'
import print from 'print-js'
import LineChart from "./LineChart.vue";
// import datetime from 'vuejs-datetimepicker';
import jspdf from "jspdf";
import html2canvas from "html2canvas";
// import { createPdfFromHtml } from "../../../../lib/createPdf";
import html2pdf from 'html2pdf.js';
export default {
  name: "App",
  props: ["id", "calldata", "type", "gid", "lora"],
  data: () => ({
    isshow: false,
    timelength: [{name: '1 Hour',value:1},{name: '2 Hours',value:2},{name: '5 Hours',value:5},{name: '10 Hours',value:10},
                 {name: '12 Hours',value:12},{name: '1 Day',value:24},{name: '7 Days',value:168},{name: '14 Days',value:336},
                 {name: '1 Month',value:720},{name: 'Custom',value:0}],
    timeselected: 1,
    MaxValue: [],
    MinValue: [],
    AvgValue: [],
    unit: [],
    read: [],
    count: [],
    maxcount: 0,
    checkarray1: [],
    render: false,
    header: [],
    mintime: "",
    maxtime: "",
    labels: [],
    tablelabels: [],
    datasets: [],
    temp: [],
    location: [],
    text: "test",
    filter: [],
    params: ["", ""],
  }),
  components: {
    LineChart,
    VueHtml2pdf
    // datetime
  },
  methods: {
    	// exportToPDF () {
			// 	html2pdf(this.$refs.document, {
			// 		margin: 0,
			// 		filename: 'document.pdf',
			// 		image: { type: 'jpeg', quality: 0.98 },
      //     enableLinks: false,
			// 		 html2canvas: {scale: 1, useCORS: true},
			// 		jsPDF: {  unit: 'in', format: 'a4', orientation: 'portrait' }
			// 	})
			// },
    close() {
      this.render = false
      this.isshow = false
      this.MaxValue = []
      this.MinValue = []
      this.AvgValue = []
    },
    download() {
      // console.log(this.$refs.print);
      this.$refs.print.$el.classList.add('pageout')
      createPdfFromHtml(this.$refs.print.$el);
    },
    savePDF() {
      //  var canvas = this.$refs.canvas.$el
      //  // console.log(canvas)
      //   html2canvas(canvas).then(function(canvas){

      //     // console.log(canvas)
      //     // var imgData = new Image();
      //     // imgData.src = canvas.toDataURL('image/png',)
      //     // // console.log(imgData)
      //     // var doc = new jspdf()
      //     // doc.addImage(imgData,'png', 150, 150)
      //     // doc.save('Export.pdf')

      //   })
      //   var canvas = document.querySelector('#canvas');
      // //creates image
      //   // console.log(canvas)
      //       var canvasImg = canvas.toDataURL("image/jpeg");

      // //creates PDF from img
      //       var doc = new jsPDF('landscape');
      //     	doc.setFontSize(20);
      //       doc.text(15, 15, "Cool Chart");
      //       	doc.addImage(canvasImg, 'JPEG', 10, 10, 280, 150 );
      //         doc.save('canvas.pdf');
      this.$refs.print.$el.classList.add('pageout')
      html2canvas(this.$refs.print.$el).then((canvas) => {
        // console.log(canvas);
        var dataURL = canvas.toDataURL();
        var pdf = new jspdf('landscape');
        pdf.addImage(dataURL, "JPEG", 20, 10, 100, 75); //addImage(image, format, x-coordinate, y-coordinate, width, height)
        pdf.save("CanvasJS Charts.pdf");
      });
    },
    findMath(Data,label) {
      // console.log(Data)
      var minVal = 0;
      var maxVal = 0;
      var sumVal = 0;
      var avgVal = 0;
      maxVal = Math.max.apply(Math, Data);
      minVal = Math.min.apply(Math, Data);
      for (var i = 0; i < Data.length; i++) {
        sumVal += parseFloat(Data);
      }
      avgVal = sumVal / Data.length;
      // // console.log(maxVal)
      // // console.log(minVal)
      // // console.log(sumVal)
      // // console.log(avgVal)
      this.MaxValue.push(maxVal);
      this.MinValue.push(minVal);
      this.AvgValue.push(avgVal.toFixed(2));
      this.tablelabels.push(label)
    },
    getyAxis(value) {
      let param = this.cutString(value).label;
      // // console.log(this.params)
      if (this.params[0] != param && this.params[0] == "") {
        // // console.log("set1 = "+param)
        this.params[0] = param;
        return "A";
      } else if (
        this.params[0] != param &&
        this.params[1] != param &&
        this.params[1] == ""
      ) {
        // // console.log("set2 = "+param)
        this.params[1] = param;
        return "B";
      }
      if (this.params[0] == param) {
        // // console.log("return params1 = "+this.params[0])
        return "A";
      } else if (this.params[1] == param) {
        // // console.log("return params2 = "+this.params[1])
        return "B";
      }
    },
    Max(num) {
      if (this.maxcount <= num) this.maxcount = num;
    },
    actionchange(item) {
      this.text = item;
    },
    async new_rerender() {
      this.params = ["", ""];
      if(!this.timeselected) {
        this.mintime = this.$moment(this.mintime).format("YYYY-MM-DD HH:mm:ss");
        this.maxtime = this.$moment(this.maxtime).format("YYYY-MM-DD HH:mm:ss");
      }else{
        this.maxtime = this.$moment().format("YYYY-MM-DD HH:mm:ss")
        this.mintime = this.$moment().subtract(this.timeselected,'hours').format("YYYY-MM-DD HH:mm:ss")
      }
      // console.log(this.mintime,this.maxtime)
      this.MaxValue = [];
      this.MinValue = [];
      this.AvgValue = [];
      var sumVal = 0;
      var con = [];
      var check = false;
      var check2 = true;
      var ind = 0;
      if(this.$moment(this.maxtime).diff(this.mintime, 'minutes') >= 60) {
        this.isshow = true
        this.checkarray1.forEach((e) => {
          con.push(this.getlabel(e));
        });
        for (let i = 0; i < con.length; i++) {
          for (let j = i + 1; j < con.length; j++) {
            if (con[i] == con[j] && check2) {
              check = true;
              check2 = false;
              ind = i;
            }
          }
          if (check) {
            con.splice(ind, 1);
            i = i - 1;
            check = false;
            check2 = true;
          }
        }
        if(con.length > 2) {
          this.$vs.notify({
            title: "Select Value",
            text: "Please select less than or equal to 2 parameters",
            color: "danger",
            position: "top-center",
            icon: "clear",
          });
        } else {
          var col = this.revert(this.checkarray1);
          var keys = [];
          col.forEach((e, i) => {
            keys.push(col[i].name);
          });
          // this.unit = col;
          // console.log(this.checkarray1)
          // console.log(col, keys);
          var color = getRandomColor();
          this.datasets = [];
          this.labels = [];
          var format = "YYYY-MM-DD HH:mm:ss";
          var data = [];
          var data2 = [];
          var tempdata = [];
          switch (this.type) {
            case "control":
              // console.log(keys)
              await this.$http.post(this.$url+'filtercontrolsensor', {
                column: this.checkarray1,
                start: this.mintime,
                end: this.maxtime,
                id: this.id,
                type: this.type,
                loc: this.text,
                gid: this.gid
              }).then((result) => {
                data = result.data
                // console.log(result.data)
              })
              for(let i = 0;i<Object.keys(data[0]).length;i++) {
                color = getRandomColor();
                data.forEach((value) => {
                  if (Object.keys(data[0])[i] == Object.keys(value)[i])
                    tempdata.push(Object.values(value)[i]);
                  if (Object.keys(value)[i] == "timestamp")
                    this.labels.push(Object.values(value)[i]);
                });
                // console.log(tempdata)
                if (i != 0)
                  this.datasets.push({
                    label: Object.keys(data[0])[i],
                    yAxisID: 'A',
                    borderColor: color,
                    pointBackgroundColor: color,
                    borderWidth: 1,
                    backgroundColor: "transparent",
                    pointBorderWidth: 1,
                    pointRadius: 3,
                    data: tempdata,
                  });
                tempdata = [];
              }
              this.unit = this.params;
              // console.log(this.labels)
              // console.log(this.params);
              break;
            case 'advantech':
              // console.log(col,keys)
              // this.checkarray1.forEach((element,i) => {
              //   switch(element) {
              //     case 'DecimalTotalFlow':
              //       this.checkarray1[i] = 'p1v00r0000x06'
              //     break;
              //     case 'IntegerTotalFlow':
              //       this.checkarray1[i] = 'p1v00r0000x09'
              //       break;
              //     case 'DecimalReverseFlow':
              //       this.checkarray1[i] = 'p1v00r0000x0a'
              //       break;
              //     case 'IntegerReverseFlow':
              //       this.checkarray1[i] = 'p1v00r0000x0b'
              //       break;
              //   }
              // });
              await this.$http.post(this.$url+'filtersensor', {
                column: this.checkarray1,
                start: this.mintime,
                end: this.maxtime,
                id: this.id,
                type: this.type,
                loc: this.text,
                gid: this.gid
              }).then((result) => {
                data = result.data
                // console.log(result.data)
              })
              for(let i = 0;i<Object.keys(data[0]).length;i++) {
                color = getRandomColor();
                data.forEach((value) => {
                  
                  if (Object.keys(data[0])[i] == Object.keys(value)[i])
                    tempdata.push(Object.values(value)[i]);
                  if (Object.keys(value)[i] == "Timestamp")
                    this.labels.push(Object.values(value)[i]);
                });
                if (Object.keys(data[0])[i] != 'Timestamp') {
                    this.findMath(tempdata,Object.keys(data[0])[i]);
                }
                if (Object.keys(data[0])[i] != 'Timestamp')
                  this.datasets.push({
                    label: Object.keys(data[0])[i],
                    yAxisID: 'A',
                    borderColor: color,
                    pointBackgroundColor: color,
                    borderWidth: 1,
                    backgroundColor: "transparent",
                    pointBorderWidth: 1,
                    pointRadius: 3,
                    data: tempdata,
                  });

                tempdata = [];
              }
              this.unit = this.params;
              // console.log(this.labels)
              // console.log(this.params);
              break;
            case "mqtt":
              // console.log(col,keys)
              // console.log({
              //   column: this.checkarray1,
              //   start: this.mintime,
              //   end: this.maxtime,
              //   id: this.id,
              //   lora: this.lora,
              //   type: this.type,
              //   gid: this.gid
              // })
              await this.$http.post(this.$url+'filtersensor', {
                column: this.checkarray1,
                start: this.mintime,
                end: this.maxtime,
                id: this.id,
                lora: this.lora,
                type: this.type,
                gid: this.gid
              }).then((result) => {
                data = result.data
                data2 = data[0]
                // console.log(result.data)
              })
              for(let i = 1;i<Object.keys(data2[0]).length;i++) {
                color = getRandomColor();
                data2.forEach((value) => {
                  
                  if (Object.keys(data2[0])[i] == Object.keys(value)[i])
                    tempdata.push(Object.values(value)[i]);
                  if (Object.keys(value)[i] == "time")
                    this.labels.push(Object.values(value)[i]);
                });
                if (Object.keys(data2[0])[i] != 'time') {
                    this.findMath(tempdata,Object.keys(data2[0])[i]);
                }
                if (Object.keys(data2[0])[i] != 'time')
                  this.datasets.push({
                    label: Object.keys(data2[0])[i],
                    yAxisID: 'A',
                    borderColor: color,
                    pointBackgroundColor: color,
                    borderWidth: 1,
                    backgroundColor: "transparent",
                    pointBorderWidth: 1,
                    pointRadius: 3,
                    data: tempdata,
                  });

                tempdata = [];
              }
              this.unit = this.params;
              // console.log(this.labels)
              // console.log(this.params);
              break;
            
            case "lora":
              // console.log(col,keys)
              // console.log({
              //   column: this.checkarray1,
              //   start: this.mintime,
              //   end: this.maxtime,
              //   id: this.id,
              //   lora: this.lora,
              //   type: this.type,
              //   gid: this.gid
              // })
              await this.$http.post(this.$url+'filtersensor', {
                column: this.checkarray1,
                start: this.mintime,
                end: this.maxtime,
                id: this.id,
                lora: this.lora,
                type: this.type,
                gid: this.gid
              }).then((result) => {
                data = result.data
                data2 = data[0]
                // console.log(result.data)
              })
              for(let i = 1;i<Object.keys(data2[0]).length;i++) {
                color = getRandomColor();
                data2.forEach((value) => {
                  
                  if (Object.keys(data2[0])[i] == Object.keys(value)[i])
                    tempdata.push(Object.values(value)[i]);
                  if (Object.keys(value)[i] == "time")
                    this.labels.push(Object.values(value)[i]);
                });
                if (Object.keys(data2[0])[i] != 'time') {
                    this.findMath(tempdata,Object.keys(data2[0])[i]);
                }
                if (Object.keys(data2[0])[i] != 'time')
                  this.datasets.push({
                    label: Object.keys(data2[0])[i],
                    yAxisID: 'A',
                    borderColor: color,
                    pointBackgroundColor: color,
                    borderWidth: 1,
                    backgroundColor: "transparent",
                    pointBorderWidth: 1,
                    pointRadius: 3,
                    data: tempdata,
                  });

                tempdata = [];
              }
              this.unit = this.params;
              // console.log(this.labels)
              // console.log(this.params);
              break;
            case "powermeter":
              await this.$http.post(this.$url+'filtersensor', {
                column: keys,
                start: this.mintime,
                end: this.maxtime,
                id: this.id,
                type: this.type,
                loc: this.text,
                gid: this.gid
              }).then((result) => {
                data = result.data[0]
                // console.log(result.data)
              })
              for(let i = 0;i<Object.keys(data[0]).length;i++) {
                color = getRandomColor();
                // // console.log(Object.keys(data[0])[i],Object.values(data[0])[i])
                data.forEach((value) => {
                  if (Object.keys(data[0])[i] == Object.keys(value)[i] && i != 0)
                    tempdata.push(Object.values(value)[i]);
                  if (Object.keys(value)[i] == "Timestamp" && i == 0)
                    this.labels.push(Object.values(value)[i]);
                });
                // // console.log(tempdata)
                // // console.log(this.checkarray1)
                if (i > 0) {
                  this.findMath(tempdata,Object.keys(data[0])[i]);
                }
                if (i != 0)
                  this.datasets.push({
                    label: Object.keys(data[0])[i],
                    yAxisID: this.getyAxis(this.checkarray1[i - 1]),
                    borderColor: color,
                    pointBackgroundColor: color,
                    borderWidth: 1,
                    backgroundColor: "transparent",
                    pointBorderWidth: 1,
                    pointRadius: 3,
                    data: tempdata,
                  });

                tempdata = [];
              }
              this.unit = this.params;
              // console.log(this.params);
              break;
            case "monnit":
              var body = {
                column: "datavalue",
                start: this.mintime,
                end: this.maxtime,
                id: this.id,
                type: this.type,
                loc: this.text,
                gid: this.gid
              }
              console.log(body)
              await this.$http.post(this.$url+'filtersensor', body).then((result) => {
                data = result.data
              })
              console.log(data)
              // console.log(this.header)
              for(let i = 0;i<this.header.length;i++) {
                // // console.log(Object.keys(data[0])[i],Object.values(data[0])[i])
                data.forEach((value,di) => {
                  // // console.log(Object.keys(value))
                  if(this.isArray(Object.values(value)) && Object.keys(value)[2] == "datatype") {
                    Object.values(value)[2].forEach((ele,index) => {
                      // // console.log(ele)
                      if(this.header[i].head) {
                        // // console.log(data[di].datavalue[index])
                        if(ele == this.checkarray1[i]){
                          if(data[di].datavalue[index] == 'False' || data[di].datavalue[index] == false) tempdata.push(0)
                          else if(data[di].datavalue[index] == 'True' || data[di].datavalue[index] == true) tempdata.push(1)
                          else tempdata.push(data[di].datavalue[index])
                        }
                      }
                    });
                  }
                  if(Object.keys(value)[i] == "date" && i == 0) this.labels.push(Object.values(value)[i])
                });
                // // console.log(tempdata)
                // if(i >0 && this.checkarray1[i-1] != null){
                // // console.log(tempdata)
                this.findMath(tempdata,Object.keys(value)[i])
                // }
                this.datasets.push({
                  label: this.checkarray1[i],
                  yAxisID: 'A',
                  borderColor: color,
                  pointBackgroundColor: color,
                  borderWidth: 1,
                  backgroundColor: "transparent",
                  pointBorderWidth: 1,
                  pointRadius: 3,
                  data: tempdata
                })
                tempdata = []
              }
              break;
          }
          
          // console.log(this.datasets)
          this.render = true
        }
        // console.log(this.MaxValue);
      }else{
        this.$vs.notify({
          title: 'Chart Error',
          text: 'Please select time more than 1 hour',
          color: 'danger',
          position: 'top-center'
        });
      }
    },
    isArray(value) {
      return value && typeof value === "object" && value.constructor === Array;
    },
    getlabel(item) {
      if (item.match("Vol")) {
        return "(V)";
      }
      if (item.match("Cur")) {
        return "(A)";
      }
      if (item.match("ActivePower")) {
        return "(W)";
      }
      if (item.match("ReactivePower")) {
        return "(Var)";
      }
      if (item.match("Apparent")) {
        return "(VA)";
      }
      if (item.match("Factor")) {
        return "(%)";
      }
      if (item.match("Freq")) {
        return "(Hz)";
      }
      if (item.match("impA") || item.match("tedA")) {
        return "(Wh)";
      }
      if (item.match("impR") || item.match("expR")) {
        return "(Varh)";
      }
    },
    cutString(item) {
      var n = item.indexOf(" ");
      var m = item.indexOf(")");
      let label = item.substr(n + 2, m - (n + 2));
      let str = item.slice(0, n);
      let ret = { name: str, label: label };
      return ret;
    },
    revert(array) {
      var newarr = array.map(this.cutString)
      
      // // console.log(newarr)
      return newarr;
    },
  },
  created() {
    var rack
    var loc = [];
    var k = 0;
    var check = true;
    for (let i = 0; i < this.calldata.length; i++) {
      loc.forEach((e) => {
        if (e == this.calldata[i].Location) {
          check = false;
        }
      });
      if (check) {
        loc.push(this.calldata[i].Location);
      }
      check = true;
      this.read[i] = JSON.parse(JSON.stringify(this.calldata[i]));
      this.count[i] = Object.keys(this.read[i]).length;
      this.Max(this.count[i]);
    }
    switch (this.type) {
      case "control":
        for (let j = 1; j <= 10; j++) {
          switch(j) {
            case 1:
              rack='AHQ'
              break;
            case 2:
              rack='ITC'
              break;
            case 3:
              rack='Finance'
              break;
            case 4:
              rack='Admin'
              break;
            case 5:
              rack='RTC'
              break;
            case 6:
              rack='Secretary'
              break;
            case 7:
              rack='Top management'
              break;
            case 8:
              rack='Cutting tool'
              break;
            case 9:
              rack='SCM, PU , Procurement'
              break;
            case 10:
              rack='Walk way'
              break;
          }
          this.header.push({
            id: j,
            head: rack
          });
        }
        break;
      case "powermeter":
        // console.log(Object.keys(this.read[0])[3]);
        for (let j = 3; j < this.maxcount - 2; j++) {
          this.header.push({
            id: j,
            head:
              Object.keys(this.read[1])[j] +
              " " +
              this.getlabel(Object.keys(this.read[1])[j]),
          });
        }
        break;
      case "advantech":
        // console.log(Object.keys(this.read[0])[3]);
        for (let j = 0; j < this.maxcount-1; j++) {
          this.header.push({
            id: j,
            head:
              Object.keys(this.read[1])[j]
          });
        }
        break;
      case "lora":
        // console.log(this.read);
        for (let j = 0; j < this.maxcount; j++) {
          if(Object.keys(this.read[1])[j] != 'name' && Object.keys(this.read[1])[j] != 'time')
          this.header.push({
            id: j,
            head: Object.keys(this.read[1])[j]
          });
        }
        break;
      case "mqtt":
        // console.log(this.read);
        for (let j = 0; j < this.maxcount; j++) {
          if(Object.keys(this.read[1])[j] != 'name' && Object.keys(this.read[1])[j] != 'time')
          this.header.push({
            id: j,
            head: Object.keys(this.read[1])[j]
          });
        }
        break;
      case "monnit":
        var temp = this.read[1].datatype.split("|");
        for (let j = 0; j < temp.length; j++) {
          if (j == 0) {
            this.header.push({
              id: j,
              head: temp[j],
            });
          } else if (this.header[k].head != temp[j]) {
            this.header.push({
              id: j,
              head: temp[j],
            });
            k++;
          }
        }
        // console.log(this.header)
        break;
    }
    this.text = loc[0]
    this.location = loc
    
    // console.log(this.location)
  }
  
};
function getRandomColor() {
  var letters = "0123456789ABCDEF".split("");
  var color = "#";
  for (var i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
}
</script>

<style scoped>
.bts{
  width: 70px;
  border-radius: 18px;
}
.vdatetime-popup__header {
  padding: 18px 30px;
  background: #00bd45;
  color: #fff;
  font-size: 32px;
}
.vdatetime-popup__actions__button {
  display: inline-block;
  border: none;
  padding: 10px 20px;
  background: transparent;
  font-size: 16px;
  color: #00bd45;
  cursor: pointer;
  transition: color .3s
}
.vdatetime-calendar__month__day--selected > span > span,
  .vdatetime-calendar__month__day--selected:hover > span > span {
    color: #fff;
    background: #00bd45;
}
.vdatetime-time-picker__item--selected {
  color: #00bd45;
  font-size: 32px;
}
.vdatetime-year-picker__item--selected {
  color: #00bd45;
  font-size: 32px;
}
.vdatetime-month-picker__item--selected {
  color: #00bd45;
  font-size: 32px;
}
</style>
